"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const merge_1 = require("merge");
const Badge_1 = require("../Badge");
const Button_1 = require("../Button");
const Divider_1 = require("../Divider");
const Selector_styles_1 = require("./Selector.styles");
const Selector = (props) => {
    const { selectorStyles, selectorInnerBoxStyles, itemStyles } = (0, Selector_styles_1.default)();
    const { selectorOverrides, selectorInnerBoxOverrides, itemOverrides } = props;
    return ((0, jsx_runtime_1.jsxs)(material_1.Box, { sx: (0, merge_1.merge)(true, selectorStyles, selectorOverrides), children: [(0, jsx_runtime_1.jsxs)(material_1.Box, { "data-testid": "innerSelector", sx: (0, merge_1.merge)(true, selectorInnerBoxStyles, selectorInnerBoxOverrides), children: [(0, jsx_runtime_1.jsx)(Badge_1.default, { "data-testid": "badge", label: props.badgeLabel }), (0, jsx_runtime_1.jsx)(material_1.Typography, { "data-testid": "text", sx: (0, merge_1.merge)(true, itemStyles, itemOverrides), children: props.item }), (0, jsx_runtime_1.jsx)(Button_1.default, { "data-testid": "button", variant: "containedLight", style: {
                            position: 'absolute',
                            right: '24px',
                        }, onClick: props.onButtonClick, children: (0, jsx_runtime_1.jsx)(material_1.Typography, { children: props.buttonLabel }) })] }), (0, jsx_runtime_1.jsx)(Divider_1.default, { type: "large" })] }));
};
exports.default = Selector;
